module.exports = __webpack_public_path__ + "img/program-research.8c147746.jpg";